import { Injectable } from '@angular/core';

import { PartnerError } from '@bytel/checkout';

import { MessageService } from '@services/message.service';

import { PartnerExclusivityErrorModalComponent } from '@shared/partner-exclusivity-error-modal/partner-exclusivity-error-modal.component';

@Injectable({
    providedIn: 'root',
})
export class HandleErrorService {
    public constructor(protected messageService: MessageService) {}

    public handleError(error: Error): void {
        if (error instanceof PartnerError) {
            this.messageService.openModal(PartnerExclusivityErrorModalComponent, {
                partner: 'votre espace bancaire',
            });
        } else {
            this.messageService.addError(error, true);
        }
    }
}
